export const mobileAppCustomiserRoutes = {
  default: 'mobile-app-customiser',
  wlAppCustomiser: {
    default: 'wl-app-customiser',
    branding: 'wl-app-customiser-branding',
    payment: 'wl-app-customiser-payment',
    profile: 'wl-app-customiser-profile',
    overview: 'wl-app-customiser-overview',
  },
  customisation: 'customisation',
}
